window.addEventListener('DOMContentLoaded', () => {
  const navToggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (navToggle && nav) navToggle.addEventListener('click', () => { const open=nav.classList.toggle('is-open'); navToggle.setAttribute('aria-expanded',String(open)); });

  const gate = document.querySelector('[data-age-gate]');
  const confirm = document.querySelector('[data-age-confirm]');
  if (gate) {
    let accepted = false;
    try {
      accepted = window.localStorage.getItem('montrieux-age-ok') === '1';
    } catch (e) {
      accepted = document.cookie.indexOf('montrieux_age_ok=1') > -1;
    }

    if (!accepted) {
      gate.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    if (confirm) confirm.addEventListener('click', () => {
      try {
        window.localStorage.setItem('montrieux-age-ok', '1');
      } catch (e) {
        document.cookie = 'montrieux_age_ok=1; path=/; max-age=31536000; SameSite=Lax';
      }
      gate.hidden = true;
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    });
  }

  document.querySelectorAll('[data-quantity-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input[name="quantity"]');
      if (!input) return;
      const current = parseInt(input.value || '1', 10);
      input.value = button.dataset.quantityButton === 'plus' ? current + 1 : Math.max(1, current - 1);
    });
  });



  let cartQueue = Promise.resolve();
  let pending = 0;
  const updateCart = (key, quantity) => {
    pending++;
    document.querySelectorAll('[name="checkout"]').forEach(b => b.disabled = true);
    cartQueue = cartQueue.then(async () => {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:key,quantity})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Modification impossible. Rechargez le panier.');
    }).catch(error => { window.alert(error.message); }).finally(() => {
      pending--;
      if (!pending) window.location.reload();
    });
  };
  document.addEventListener('click', event => {
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) { event.preventDefault(); updateCart(remove.dataset.cartLine,0); return; }
    const button = event.target.closest('[data-cart-quantity-button]');
    if (!button) return;
    const input = button.closest('[data-quantity-control]').querySelector('input');
    input.value = Math.max(0, (parseInt(input.value,10)||0)+(button.dataset.cartQuantityButton === 'plus'?1:-1));
    updateCart(input.dataset.cartLine,Number(input.value));
  });
  document.addEventListener('change', event => {
    const input=event.target.closest('input[data-cart-line]');
    if(input) updateCart(input.dataset.cartLine,Math.max(0,parseInt(input.value,10)||0));
  });
  document.addEventListener('submit', event => {
    if (pending && event.target.matches('.cart-layout')) event.preventDefault();
  });
  document.querySelectorAll('[data-product-thumb]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const main = document.querySelector('[data-product-main-image]');
      if (!main || !btn.dataset.largeSrc) return;
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = btn.dataset.largeSrc;
      document.querySelectorAll('[data-product-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b===btn)));
      if (btn.dataset.alt) main.alt = btn.dataset.alt;
    });
  });
});

window.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-award-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.awardOpen);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }
    const closer = event.target.closest('[data-award-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) dialog.close();
    }
  });
  document.querySelectorAll('.award-dialog').forEach((dialog) => {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
 const variantsNode=document.querySelector('[data-product-variants]');
 const selects=document.querySelectorAll('.product-form select[name="id"], .booking-product-form select[data-variant-select]');
 if(variantsNode && selects.length){
   const variants=JSON.parse(variantsNode.textContent);
   selects.forEach(select => select.addEventListener('change',()=>{
     const v=variants.find(v=>String(v.id)===select.value);if(!v)return;
     const price=document.querySelector('[data-product-price]');if(price)price.textContent=v.price;
     const form=select.closest('form');
     const variantInput=form?.querySelector('input[data-variant-id]');
     if(variantInput){variantInput.value=String(v.id);variantInput.dispatchEvent(new Event('change',{bubbles:true}));}
     const button=form ? form.querySelector('.product-form__submit') : document.querySelector('.product-form__submit');
     if(button){button.disabled=!v.available;if(!button.hasAttribute('data-booking-trigger')){button.textContent=v.available?(button.hasAttribute('data-gift-card-submit')?'Ajouter cette carte au panier':'Ajouter au panier'):'Épuisé';}else if(!v.available){button.textContent='Épuisé';}}
     const img=document.querySelector('[data-product-main-image]');if(img&&v.image){img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=v.image;}
     const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);
     document.dispatchEvent(new CustomEvent('montrieux:variant-change',{detail:{variant:v,variantId:v.id}}));
   }));
 }
 const gate=document.querySelector('[data-age-gate]');
 if(gate&&!gate.hidden){gate.querySelector('button')?.focus();gate.addEventListener('keydown',e=>{if(e.key!=='Tab')return;const list=gate.querySelectorAll('button,a[href]');const first=list[0],last=list[list.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}});}
});


// Montrieux V14 — Appointo contrôle intégralement Solo / Duo et le créneau.
// Une soumission manuelle de l'ancien formulaire ne doit jamais acheter
// une prestation sans propriété Appointo. Appointo dispose de sa propre UI.
document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('form.booking-product-form');
  if (!form) return;
  const error = form.querySelector('[data-booking-error]');
  const widget = form.querySelector('.appointo-embed-wrap');
  const variantInput = form.querySelector('[data-appointo-hidden-variant]');
  const hasSlot = () => Array.from(form.querySelectorAll(
    'input[name="properties[_start_time]"], select[name="properties[_start_time]"]'
  )).some(el => String(el.value || '').trim() !== '');

  form.addEventListener('submit', event => {
    if (hasSlot()) {
      if (error) error.hidden = true;
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (error) error.hidden = false;
    widget?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);

  // Le sélecteur de variantes Appointo est injecté hors du formulaire.
  // Synchronisation passive de l'ID caché du formulaire Shopify :
  // elle ne remplace et n'intercepte aucun gestionnaire Appointo.
  if (variantInput) {
    document.addEventListener('change', event => {
      if (event.target?.id !== 'appointo-variant-select') return;
      const id = String(event.target.value || '').trim();
      if (!/^\d+$/.test(id)) return;
      const variantsNode = document.querySelector('[data-product-variants]');
      if (!variantsNode) return;
      try {
        const variants = JSON.parse(variantsNode.textContent);
        if (!variants.some(v => String(v.id) === id && v.available)) return;
        variantInput.value = id;
      } catch (_) { /* Ne jamais empêcher Appointo de fonctionner. */ }
    });
  }
});
